import { Component, HostListener, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogStopAuctionData {
  question: string;
  showCloseScheduledBidsToggle: boolean;
}

export interface DialogStopAuctionResult {
  closeScheduledBids: boolean;
}

@Component({
  selector: 'app-dialog-stop-auction',
  templateUrl: 'dialog-stop-auction.component.html',
  styles: [
    '.dialog-content { min-height: 100px; }',
  ],
})
export class DialogStopAuctionComponent {
  public closeScheduledBids = true;

  constructor(
    public readonly dialogRef: MatDialogRef<DialogStopAuctionComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: DialogStopAuctionData
  ) {}

  @HostListener('window:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent): void {
    event.preventDefault();
    this.onYesClick();
  }

  @HostListener('window:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent): void {
    event.preventDefault();
    this.onNoClick();
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    const result: DialogStopAuctionResult = {
      closeScheduledBids: this.data.showCloseScheduledBidsToggle
        ? this.closeScheduledBids
        : false,
    };
    this.dialogRef.close(result);
  }
}
